import React from 'react';
import { OvertimeWorkedAndScheduledPerPeriodModel } from '../../models/OvertimeSchedule';
import { PeriodDate } from '../../utils/period.utils';
import { getTotalScheduledOvertimeByDate, getTotalWorkedOvertimeByDate } from '../../utils/overtimeTotals.utils';
import { DaysTableBody, EmployeeTableBody, ResumenTableBody } from './OverTimeScheduleTableContent';
import { RESUMEN_COLUMNS } from './resumenColumns.config';

interface Props {
  data: OvertimeWorkedAndScheduledPerPeriodModel[];
  periodDates: PeriodDate[];
  selectedPeriodIndex: number;
  disabled?: boolean;
}

const TABLE_CLASS = 'table align-middle table-nowrap table-striped table-hover table-bordered mb-0 p-0';

export const OverTimeScheduleTable = ({ data, periodDates, selectedPeriodIndex, disabled = false }: Props) => {
  return (
    <div className="overtime-schedule-layout">
      <div className="overtime-schedule-employee-pane">
        <table className={TABLE_CLASS} style={{ tableLayout: 'fixed', width: '170px' }}>
          <thead className="table-light">
            <tr className="">
              <th rowSpan={2} scope="col" className="align-middle fw-bold text-dark " style={{ height: '102.71px' }}>
                <span className="fs-4 p-0 m-0">Persona</span>
              </th>
            </tr>
            <tr />
          </thead>
          <EmployeeTableBody data={data} />
        </table>
      </div>

      <div className="overtime-schedule-days-pane">
        <table className={TABLE_CLASS}>
          <thead className="table-light">
            <tr>
              {periodDates.map((periodDate) => (
                <th
                  key={`header-${periodDate.dateKey}`}
                  colSpan={2}
                  scope="colgroup"
                  className="text-center align-middle fw-bold text-dark  overtime-schedule-day-col"
                >
                  {periodDate.label}
                </th>
              ))}
            </tr>

            <tr>
              {periodDates.map((periodDate) => (
                <React.Fragment key={periodDate.dateKey}>
                  <th scope="col" className="text-center align-middle  overtime-schedule-day-col">
                    <div className="fw-normal text-muted">
                      <div
                        className="d-flex align-items-center justify-content-center gap-1 small fw-medium"
                        style={{ fontSize: '0.7rem' }}
                      >
                        <i className="mdi mdi-calendar-clock-outline text-primary2" title="Proyectadas" />
                        Proy
                      </div>

                      <div className=" fw-bolder text-muted" style={{ fontSize: '0.7rem' }}>
                        {getTotalScheduledOvertimeByDate(data, selectedPeriodIndex, periodDate.dateKey).toFixed(2)}
                      </div>
                    </div>
                  </th>

                  <th scope="col" className="text-center align-middle  overtime-schedule-day-col">
                    <div className="fw-normal text-muted">
                      <div
                        className="d-flex align-items-center justify-content-center gap-1 small fw-medium"
                        style={{ fontSize: '0.7rem' }}
                      >
                        <i className="mdi mdi-clock-outline text-info" title="Ejecutadas" />
                        Ejec
                      </div>

                      <div className=" fw-bolder text-muted" style={{ fontSize: '0.7rem' }}>
                        {getTotalWorkedOvertimeByDate(data, selectedPeriodIndex, periodDate.dateKey).toFixed(2)}
                      </div>
                    </div>
                  </th>
                </React.Fragment>
              ))}
            </tr>
          </thead>

          <DaysTableBody
            data={data}
            periodDates={periodDates}
            selectedPeriodIndex={selectedPeriodIndex}
            disabled={disabled}
          />
        </table>
      </div>

      <div className="overtime-schedule-resumen-pane">
        <table className={TABLE_CLASS} style={{ tableLayout: 'fixed', width: '244px' }}>
          <thead className="table-light">
            <tr>
              <th
                colSpan={4}
                scope="colgroup"
                className="text-center align-middle fw-bold text-dark overtime-schedule-day-col"
              >
                Resumen
              </th>
            </tr>

            <tr>
              {RESUMEN_COLUMNS.map((column) => (
                <th
                  key={column.key}
                  scope="col"
                  title={column.title}
                  className="text-center align-middle overtime-schedule-day-col"
                >
                  <div className="fw-normal text-muted">
                    <div
                      className="d-flex align-items-center justify-content-center gap-1 small fw-medium"
                      style={{ fontSize: '0.7rem' }}
                    >
                      {column.icon && <i className={`${column.icon} ${column.iconClassName ?? ''}`} />}

                      {column.label}
                    </div>

                    <div className="fw-bolder text-muted tabular-nums" style={{ fontSize: '0.7rem' }}>
                      {column.getTotal(data, selectedPeriodIndex).toFixed(2)}
                    </div>
                  </div>
                </th>
              ))}
            </tr>
          </thead>

          <ResumenTableBody data={data} selectedPeriodIndex={selectedPeriodIndex} />
        </table>
      </div>
    </div>
  );
};
